import useGetMyProducts from './useGetMyProducts'

export default useGetMyProducts
